export default "__VITE_ASSET__2f19473e__"